import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import NavLogo from "./NavLogo";
import NavContent from "./NavContent";

import NavBar from "../../../../components/NavBar";

import Aux from "../../../../components/common/Aux";
import * as actionTypes from "./../../../../store/actions";
import navigation from "../../../../menu-items";

import navImage1 from "../../../../assets/images/nav-bg/navbar-img-1.jpg";
import navImage2 from "../../../../assets/images/nav-bg/navbar-img-2.jpg";
import navImage3 from "../../../../assets/images/nav-bg/navbar-img-3.jpg";
import navImage4 from "../../../../assets/images/nav-bg/navbar-img-4.jpg";
import navImage5 from "../../../../assets/images/nav-bg/navbar-img-5.jpg";
import AuthClient from "../../../../api";

import DeviceDashSearch from "../../../../components/SearchBar";



class Navigation extends Component {
  state = {
    isopen: false,
  };
  async componentDidMount() {
    this.initResize();
    this.fetchNavData();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  initResize = () => {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  };

  toggleOpen = (open) => {
    this.setState({ ...this.state, isopen: open });
  }

  handleResize = () => {
    const contentWidth = document.getElementById("root").clientWidth;

    if (this.props.layout === "horizontal" && contentWidth < 992) {
      this.props.onChangeLayout("vertical");
    }
  };

  fetchNavData = async () => {
    let { data } = await AuthClient.get("/getNavData");
    this.props.setDeviceCount(data.data?.devices ?? 0);
    this.props.setPendingCount(data.data?.pending ?? 0);
    this.props.setAlertCount(data.data?.alerts ?? 0);
    this.props.setUserPerms(data.data?.perms ?? []);
  }

  render() {
    let navClass = ["pcoded-navbar"];

    if (
      this.props.preLayout !== null &&
      this.props.preLayout !== "" &&
      this.props.preLayout !== "layout-6" &&
      this.props.preLayout !== "layout-8"
    ) {
      navClass = [...navClass, this.props.preLayout];
    } else {
      navClass = [
        ...navClass,
        this.props.layoutType,
        this.props.navBackColor,
        this.props.navBrandColor,
        "drp-icon-" + this.props.navDropdownIcon,
        "menu-item-icon-" + this.props.navListIcon,
        this.props.navActiveListColor,
        this.props.navListTitleColor,
      ];

      if (this.props.layout === "horizontal") {
        navClass = [...navClass, "theme-horizontal"];
      }

      if (this.props.navBackImage) {
        navClass = [...navClass, this.props.navBackImage];
      }

      if (this.props.navIconColor) {
        navClass = [...navClass, "icon-colored"];
      }

      if (!this.props.navFixedLayout) {
        navClass = [...navClass, "menupos-static"];
      }

      if (this.props.navListTitleHide) {
        navClass = [...navClass, "caption-hide"];
      }
    }

    if (this.props.windowWidth < 992 && this.props.collapseMenu) {
      navClass = [...navClass, "mob-open"];
    } else if (this.props.collapseMenu) {
      navClass = [...navClass, "navbar-collapsed"];
    }

    if (this.props.preLayout === "layout-6") {
      document.body.classList.add("layout-6");
      document.body.style.backgroundImage = this.props.layout6Background;
      document.body.style.backgroundSize = this.props.layout6BackSize;
    }

    if (this.props.preLayout === "layout-8") {
      document.body.classList.add("layout-8");
    }

    if (this.props.layoutType === "dark") {
      document.body.classList.add("datta-dark");
    } else {
      document.body.classList.remove("datta-dark");
    }

    if (this.props.rtlLayout) {
      document.body.classList.add("datta-rtl");
    } else {
      document.body.classList.remove("datta-rtl");
    }

    if (this.props.boxLayout) {
      document.body.classList.add("container");
      document.body.classList.add("box-layout");
    } else {
      document.body.classList.remove("container");
      document.body.classList.remove("box-layout");
    }

    let backImage, navStyle;
    if (this.props.navBackImage) {
      switch (this.props.navBackImage) {
        case "navbar-image-1":
          backImage = navImage1;
          break;
        case "navbar-image-2":
          backImage = navImage2;
          break;
        case "navbar-image-3":
          backImage = navImage3;
          break;
        case "navbar-image-4":
          backImage = navImage4;
          break;
        case "navbar-image-5":
          backImage = navImage5;
          break;
        default:
          backImage = "";
      }
      navStyle = {
        backgroundImage: `url(${backImage})`,
      };
    }
    
    return (
      <Aux>
        <nav className={navClass.join(" ")} style={navStyle}>
          <div style={{ display: 'flex' }} >
            <div style={{ display: 'block', textAlign: 'center' }} className="navbar-wrapper">
              <NavLogo
                collapseMenu={this.props.collapseMenu}
                windowWidth={this.props.windowWidth}
                onToggleNavigation={this.props.onToggleNavigation}
              />
              <NavContent navigation={navigation.items} />
            </div>
            <DeviceDashSearch setOpen={this.props.toggleSearch} open={this.props.openSearch} />
          </div>
        </nav>
        <NavBar />
      </Aux>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.main.layout,
    preLayout: state.main.preLayout,
    collapseMenu: state.main.collapseMenu,
    layoutType: state.main.layoutType,
    navBackColor: state.main.navBackColor,
    navBackImage: state.main.navBackImage,
    navIconColor: state.main.navIconColor,
    navBrandColor: state.main.navBrandColor,
    layout6Background: state.main.layout6Background,
    layout6BackSize: state.main.layout6BackSize,
    rtlLayout: state.main.rtlLayout,
    navFixedLayout: state.main.navFixedLayout,
    boxLayout: state.main.boxLayout,
    navDropdownIcon: state.main.navDropdownIcon,
    navListIcon: state.main.navListIcon,
    navActiveListColor: state.main.navActiveListColor,
    navListTitleColor: state.main.navListTitleColor,
    navListTitleHide: state.main.navListTitleHide,
    openSearch: state.main.openSearch,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToggleNavigation: () => dispatch({ type: actionTypes.COLLAPSE_MENU }),
    onChangeLayout: (layout) => dispatch({ type: actionTypes.CHANGE_LAYOUT, layout: layout }),
    setDeviceCount: (val) => dispatch({ type: "DEVICE_COUNT", payload: val }),
    setPendingCount: (val) => dispatch({ type: "PENDING_COUNT", payload: val }),
    setAlertCount: (val) => dispatch({ type: "ALERT_COUNT", payload: val }),
    setUserPerms: (val) => dispatch({ type: "USER_PERMS", payload: val }),
    toggleSearch: (val) => dispatch({ type: "TOGGLE_SEARCH", payload: val }),
  };
};

const NavigationWithRedux = connect(mapStateToProps, mapDispatchToProps)(Navigation);
const NavigationWithRouterAndRedux = withRouter(NavigationWithRedux);

export default NavigationWithRouterAndRedux;
